export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_POSTS = 'FETCH_POSTS';
export const NEW_POST = 'NEW_POST';
export const CART_ITEMS = 'CART_ITEMS';
export const ACCOUNT_ITEM = 'ACCOUNT_ITEM';
